module.exports = __webpack_public_path__ + "static/media/add-icon.f5e93449.PNG";